import { Tooltip } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import type { TargetProfitType as TargetProfitTypeTyping } from '@/store/targetAccumulator/state.ts';

const TargetProfitType = () => {
  const profitType = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.targetProfitType ?? 'NONE',
  );
  const profitTypeList = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.targetProfitTypeList,
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleprofitType = (event: React.ChangeEvent<HTMLSelectElement>) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'Profit Type changed', event.target.value);

    return checkTargetAccumulatorWithTradeCapture({
      targetProfitType: event.target.value as TargetProfitTypeTyping,
    });
  };

  return (
    <TargetAccumulatorFormField
      formattedMessageId="targetAccumulator.form.profitType"
      extra={
        <Tooltip
          position="right"
          contents={<FormattedMessage id={`targetAccumulator.form.profitType.info.${profitType}`} />}
        >
          <div className="badge badge-dismissible">
            <em className="icon icon-sm cursor-default line-height-1 text-secondary">info_outline</em>
          </div>
        </Tooltip>
      }
    >
      <Form.Select value={profitType} onChange={handleprofitType} size="sm" data-e2e="profit-type-selector">
        {profitTypeList?.map((mode) => (
          <option key={mode} value={mode}>
            <FormattedMessage id={`targetAccumulator.form.profitType.${mode}`} />
          </option>
        ))}
      </Form.Select>
    </TargetAccumulatorFormField>
  );
};

export default TargetProfitType;
